import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  UncontrolledDropdown,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import classnames from "classnames";
import Countdown from "react-countdown";
import { Link } from "react-router-dom";

import { useParams } from "react-router-dom";
import useSWR from "swr";
import { publicAPIClient } from "../../utils/api_helper";
// Import Images
import Img1 from "../../assets/images/nft/img-01.jpg";

import Img5 from "../../assets/images/nft/img-05.jpg";

//SimpleBar
import SimpleBar from "simplebar-react";
import DonateMoney from "./DonateMoney";
import SettingsSkeleton from "../../Components/Skeletons/SettingsSkeleton";

const api = new publicAPIClient();

const transactionListFetcher = async (url) => {
  const { data } = await api.get(url);
  return data;
};

const CrowdFundDonatePage = () => {
  document.title = "Donate | SimplyPay";
  const { id } = useParams();

  let { data, error, isValidating } = useSWR(
    `/crowdfund/donation/${id || ""}/crowdfund-detail/`,
    transactionListFetcher,
    {
      revalidateOnFocus: false, // revalidate when the page gains focus
      revalidateOnReconnect: false, // revalidate when the browser regains network connectivity
    }
  );

  console.log(data, "CROWDDDD__FUND__DATAAA");

  const [customActiveTab, setcustomActiveTab] = useState("1");
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return <span>You are good to go!</span>;
    } else {
      return (
        <>
          <h5 id="auction-time-1" className="mb-0">
            {days} : {hours} : {minutes} : {seconds}
          </h5>
        </>
      );
    }
  };

  return (
    <React.Fragment>
      <SettingsSkeleton>
        {data ? (
          <div className="page-content">
            <Container fluid>
              {/* <BreadCrumb title="Item Details" pageTitle="NFT Marketplace" /> */}
              <Card>
                <CardBody>
                  <Row className="g-4">
                    <Col lg={4}>
                      <div className="sticky-side-div">
                        <Card className="ribbon-box border shadow-none right">
                          <img src={data?.image} alt="" className="img-fluid rounded" />
                        </Card>
                        <div className="hstack gap-2">
                          <button className="btn btn-success w-100">
                            <Link to={`/cf-page/${data?.slug}/`} className="text-white">
                              go back
                            </Link>
                          </button>
                        </div>
                      </div>
                    </Col>
                    <Col lg={8}>
                      <div>
                        <span className="badge badge-soft-info mb-3 fs-12">
                          <i className="ri-eye-line me-1 align-bottom"></i>
                          {data?.donor_count} people have donated
                        </span>
                        <h4>{data?.title}</h4>
                        <div className="hstack gap-3 flex-wrap">
                          <div className="text-muted">
                            Creators :{" "}
                            <Link to="#" className="text-primary fw-medium">
                              {data?.user?.user?.first_name} {data?.user?.user?.last_name}
                            </Link>
                          </div>
                          <div className="vr"></div>

                          <div className="vr"></div>
                          <div className="text-muted">
                            Published : <span className="text-body fw-medium">{data?.created_at}</span>
                          </div>
                        </div>

                        <Row className="mt-4">
                          <Col lg={6} sm={6}>
                            <div className="p-2 border border-dashed rounded text-center">
                              <div>
                                <p className="text-muted fw-medium mb-1">Target :</p>
                                <h5 className="fs-17 text-success mb-0">
                                  <i className="mdi mdi-ethereum me-1"></i>GHS {data?.target_amount}
                                </h5>
                              </div>
                            </div>
                          </Col>

                          <Col lg={6} sm={6}>
                            <div className="p-2 border border-dashed rounded text-center">
                              <div>
                                <p className="text-muted fw-medium mb-1">Amount raised</p>
                                <h5 className="fs-17 mb-0">GHS {data?.current_amount} </h5>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <div className="mt-4 text-muted">
                          {/* <h5 className="fs-14">Description :</h5> */}
                          <p>{data?.description}</p>
                        </div>
                        <div className="product-content mt-5">
                          {/* <h5 className="fs-14 mb-3">Product Description :</h5> */}

                          <Nav tabs className="nav-tabs-custom nav-success">
                            <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  active: customActiveTab === "1",
                                })}
                                onClick={() => {
                                  toggleCustom("1");
                                }}
                              >
                                Mobile money
                              </NavLink>
                            </NavItem>
                          </Nav>
                          <TabContent
                            activeTab={customActiveTab}
                            className="border border-top-0 p-0 p-sm-4"
                            id="nav-tabContent"
                          >
                            <TabPane id="nav-speci" tabId="1">
                              <DonateMoney id={id} />
                            </TabPane>
                          </TabContent>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Container>
          </div>
        ) : null}
      </SettingsSkeleton>
    </React.Fragment>
  );
};

export default CrowdFundDonatePage;
